// src/components/RideTypeSelector.jsx
import React, { useState } from "react";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import { useBookingDispatch } from "./BookingContext";
import { useNavigate } from "react-router-dom"; // ← if you route
import "./BookingFlow.css";

const rideOptions = [
  { id: "airport", label: "Airport", icon: "/icons/web_airport.png" },
  { id: "outstation", label: "Outstation", icon: "/icons/web_outstation.png" },
  { id: "rental", label: "Rentals", icon: "/icons/web_rental.png" },
  { id: "intracity", label: "Local ride", icon: "/icons/web_local.png" },
];

export default function RideTypeSelector() {
  const dispatch = useBookingDispatch();
  const navigate = useNavigate(); // remove if you don’t navigate
  const [expanded, setExpanded] = useState(null); // only 'airport' toggles here
  const airportOpen = expanded === "airport";

  /** helper: reset, set ride type, and go to details */
  const selectRideType = (type) => {
    dispatch({ type: "RESET" });
    dispatch({ type: "SELECT_RIDE_TYPE", payload: type });
    //navigate('/details');                      // comment out if un-needed
  };

  /** helper: choose a terminal (airport ride) */
  const chooseTerminal = (terminalId) => {
    dispatch({ type: "RESET" });
    dispatch({ type: "SELECT_RIDE_TYPE", payload: "airport" });
    dispatch({ type: "SELECT_TERMINAL", payload: terminalId });
    //navigate('/details');                      // comment out if un-needed
  };

  return (
    <motion.div
      className="bf-step"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="bf-title">Pick your ride type to get started</div>

      <LayoutGroup>
        <div className="bf-ride-options-container">
          {rideOptions.map((opt) => {
            if (airportOpen && opt.id !== "airport") return null; // hide others

            const isAirport = opt.id === "airport";
            const isExpanded = isAirport && airportOpen;

            return (
              <motion.div
                key={opt.id}
                className={`bf-option-card ${isExpanded ? "selected" : ""}`}
                layout
                transition={{ type: "spring", stiffness: 350, damping: 30 }}
                onClick={() => {
                  if (!isAirport) selectRideType(opt.id);
                  else if (!airportOpen) setExpanded("airport"); // expand
                  else setExpanded(null); // collapse
                }}
              >
                {isExpanded ? (
                  <>
                    {/* Airport expanded: icon + inline terminals */}
                    <div className="bf-option-top">
                      <div className="bf-option-icon-wrapper">
                        <img
                          src={opt.icon}
                          alt={opt.label}
                          className="bf-option-icon"
                        />
                      </div>
                      <AnimatePresence initial={false}>
                        <motion.div
                          className="bf-inline-terminals"
                          initial={{ opacity: 0, width: 0 }}
                          animate={{ opacity: 1, width: "auto" }}
                          exit={{ opacity: 0, width: 0 }}
                          transition={{ duration: 0.25 }}
                        >
                          <button
                            className="bf-term-btn"
                            onClick={() => chooseTerminal("01")}
                          >
                            Terminal&nbsp;01
                          </button>
                          <button
                            className="bf-term-btn"
                            onClick={() => chooseTerminal("02")}
                          >
                            Terminal&nbsp;02
                          </button>
                        </motion.div>
                      </AnimatePresence>
                    </div>
                    <div className="bf-option-bottom">{opt.label}</div>
                  </>
                ) : (
                  <>
                    {/* Compact card */}
                    <div className="bf-option-icon-wrapper">
                      <img
                        src={opt.icon}
                        alt={opt.label}
                        className="bf-option-icon"
                      />
                    </div>
                    <div className="bf-option-label-wrapper">{opt.label}</div>
                  </>
                )}
              </motion.div>
            );
          })}
        </div>
      </LayoutGroup>
    </motion.div>
  );
}

// // src/components/RideTypeSelector.jsx
// import React, { useState } from 'react'
// import { motion, AnimatePresence, LayoutGroup } from 'framer-motion'
// import { useBookingDispatch } from './BookingContext'
// import './BookingFlow.css'

// const rideOptions = [
//   { id: 'airport',    label: 'Airport',    icon: '/icons/web_airport.svg' },
//   { id: 'outstation', label: 'Outstation', icon: '/icons/web_outstation.svg' },
//   { id: 'rental',    label: 'Rentals',    icon: '/icons/web_rental.svg' },
//   { id: 'intracity',      label: 'Local ride', icon: '/icons/web_local.svg' },
// ]

// export default function RideTypeSelector() {
//   const dispatch        = useBookingDispatch()
//   const [selected, set] = useState(null)
//   const airportOpen     = selected === 'airport'

//   return (
//     <motion.div
//       className="bf-step"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit   ={{ opacity: 0, y: -20 }}
//     >
//       <div className="bf-title">Pick your ride type to get started</div>

//       <LayoutGroup>
//         <div className="bf-ride-options-container">
//           {rideOptions.map(o => {
//             // when airport is open, hide the other cards
//             if (airportOpen && o.id !== 'airport') return null

//             const isAirport  = o.id === 'airport'
//             const isExpanded = isAirport && airportOpen

//             return (
//               <motion.div
//                 key={o.id}
//                 className={`bf-option-card ${isExpanded ? 'selected' : ''}`}
//                 layout
//                 transition={{ type: 'spring', stiffness: 350, damping: 30 }}
//                 onClick={() => {
//                   if (isAirport) {
//                     if (!airportOpen) {
//                       // first click on Airport → go to terminal step
//                       dispatch({ type: 'RESET' });
//                       set('airport')
//                       dispatch({ type: 'SELECT_RIDE_TYPE', payload: 'airport' })

//                     } else {
//                       // second click → just collapse UI (stay on rideType step)
//                       set(null)
//                     }
//                   } else {
//                     // non-airport → go straight to details
//                     dispatch({ type: 'RESET' });
//                     dispatch({ type: 'SELECT_RIDE_TYPE', payload: o.id })
//                   }
//                 }}
//               >
//                 {isExpanded ? (
//                   <>
//                     {/* Airport expanded: icon + inline terminals */}
//                     <div className="bf-option-top">
//                       <div className="bf-option-icon-wrapper">
//                         <img src={o.icon} alt={o.label} className="bf-option-icon" />
//                       </div>
//                       <AnimatePresence initial={false}>
//                         <motion.div
//                           className="bf-inline-terminals"
//                           initial={{ opacity: 0, width: 0 }}
//                           animate={{ opacity: 1, width: 'auto' }}
//                           exit   ={{ opacity: 0, width: 0 }}
//                           transition={{ duration: 0.25 }}
//                         >
//                           <button
//                             className="bf-term-btn"
//                             onClick={() =>
//                             {  dispatch({ type: 'RESET' })
//                               dispatch({ type: 'SELECT_TERMINAL', payload: '01' })}
//                             }
//                           >
//                             Terminal 01
//                           </button>
//                           <button
//                             className="bf-term-btn"
//                             onClick={() =>
//                               {dispatch({ type: 'RESET' });
//                               dispatch({ type: 'SELECT_TERMINAL', payload: '02' })}
//                             }
//                           >
//                             Terminal 02
//                           </button>
//                         </motion.div>
//                       </AnimatePresence>
//                     </div>
//                     <div className="bf-option-bottom">{o.label}</div>
//                   </>
//                 ) : (
//                   <>
//                     {/* Default (compact) card */}
//                     <div className="bf-option-icon-wrapper">
//                       <img src={o.icon} alt={o.label} className="bf-option-icon" />
//                     </div>
//                     <div className="bf-option-label-wrapper">{o.label}</div>
//                   </>
//                 )}
//               </motion.div>
//             )
//           })}
//         </div>
//       </LayoutGroup>
//     </motion.div>
//   )
// }
